import Repository from './repository'

const resource = 'files';

export default {
    async shareFile(payload) {
        Repository.headers = {
            ...Repository.headers,
            'Content-Type': 'multipart/form-data'
        };
        let response = await Repository.post(`${resource}/shared`, payload);
        return response;
    },
    async postFile(payload) {
        Repository.headers = {
            ...Repository.headers,
            'Content-Type': 'multipart/form-data'
        };
        let response = await Repository.post(`${resource}/file`, payload);
        return response;
    },
    async getFile({ fileId }) {
        let response = await Repository.get(`${resource}/file/${fileId}/download`, { responseType: 'blob' });
        return { data: response.data, contentType: response.headers['content-type'] }
    },
    async getFiles({ roomId }) {
        let url = `${resource}/shared/${roomId}`;
        let response = await Repository.get(url);
        return response;
    },
    async postPhoto(payload) {
        let response = await Repository.post(`${resource}/photo`, payload);
        return response;
    },
    async getPhoto({ photoId }) {
        let response = await Repository.get(`${resource}/photo/${photoId}/download`, { responseType: 'blob' });
        return {
            data: response.data,
            contentType: "image/png"
        }
    },
    async signSharedFile(payload) {
        let url = `${resource}/share/${payload.fileId}/sign`;
        let response = await Repository.post(url, payload);
        return response;
    },
    async uploadVideo(payload) {
        Repository.headers = {
            ...Repository.headers,
            'Content-Type': 'multipart/form-data'
        };
        let response = await Repository.post(`${resource}/video`, payload);
        return response;
    }
}